export default __webpack_public_path__ + "static/media/LeftButton.f05796be.svg";